

























































































import State from '@/classes/state';
import { getMarkerModifier } from '@/utility/map-utils';
import Dealer from '@/models/dealer.model';
import { DealerDetails } from '@/models/dealer-details.model';

export default {
    name: 'DealerInfo',
    props: {
        type: {
            type: String,
            required: true,
        },
        marker: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    data() {
        const state: State = this.$store.state;

        return {
            translations: state.translations,
        };
    },
    computed: {
        dealer(): Dealer {
            return this.marker.data;
        },
        isDetail(): boolean {
            return this.type === 'detail';
        },
        telLink(): string | null {
            const phone = this.dealer.properties.phone;

            if (!phone) {
                return null;
            }

            const replacedPhone = phone.replace(/\D/g, '');

            return `tel:${replacedPhone}`;
        },
        faxLink(): string | null {
            const fax = this.dealer.properties.fax;

            if (!fax) {
                return null;
            }

            const replacedFax = fax.replace(/\D/g, '');

            return `fax:${replacedFax}`;
        },
        mailLink(): string | null {
            const email = this.dealer.properties.email;

            if (!email) {
                return null;
            }

            return `mailto:${email}`;
        },
        distance(): string | null {
            const state: State = this.$store.state;
            const myPlace = state.myPlace;

            if (!myPlace) {
                return null;
            }

            const config = state.config;
            const translations = state.translations;
            const dealer: Dealer = this.dealer;
            const formattedDistance = parseFloat(dealer.properties.distance.toFixed(config.map.distanceDecimals)).toLocaleString();

            return `${formattedDistance} ${translations.distanceUnit}`;
        },
        markerModifier(): string | null {
            const state: State = this.$store.state;
            const dealer: Dealer = this.dealer; 
            const config = state.config;           
            let centerFilter: string = "none"
            if (config.marker.centerFilter != '') centerFilter = config.marker.centerFilter

            if (dealer) {
                const cat2: string = dealer.properties.cat2
                //const { mapIconID } = dealer.properties;
                //const markerModifier = getMarkerModifier(mapIconID);
                const markerModifier = getMarkerModifier((cat2.indexOf(centerFilter) > -1) ? 'center' : '');
            
                if (markerModifier) {
                    return markerModifier;
                }
            }

            return null;
        },
        dealerStatus(): string | null {
            const dealer: Dealer = this.dealer; 
            const { markerIcons, config } = this.$store.state;
            let centerFilter: string = "none"
            
            if (config.marker.centerFilter != '') centerFilter = config.marker.centerFilter

            if (dealer) {
                const cat2: string = dealer.properties.cat2
                
                if ((cat2.indexOf(centerFilter) > -1)) {
                    return markerIcons['center'].name;
                }
            }

            return null;
        },
    },
    methods: {
        handleBackButtonClick() {
            this.$emit('closeDetails');
        },
        handleDetailButtonClick() {
            const dealerDetails: DealerDetails = {
                dealer: this.dealer,
                marker: this.marker,
                index: this.index,
            };

            this.$emit('openDetails', dealerDetails);
        },
    },
}
